import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevron-up",
  "use": "chevron-up-usage",
  "viewBox": "0 0 15 9",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 9\" id=\"chevron-up\"><path fill=\"currentColor\" d=\"M1.43 8.998L0 7.558l.715-.72 5.158-5.2.716-.72.911-.92.715.721 6.07 6.117.715.72L13.57 9l-.716-.721L7.5 2.882l-.196.198-5.158 5.198z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol